/*
 * vg-size-guide-modal.js — Victoria's Gala
 * - Injects a "Guía de tallas" trigger button next to the Talla legend.
 * - Also responds to ANY element with [data-vg-open-size] to open the modal.
 * - Re-injects when variant-picker AJAX re-renders.
 * - ESC, backdrop click, and X button close it.
 */
(function () {
  'use strict';

  function getModal() {
    return document.getElementById('vg-size-guide-modal');
  }

  function openModal() {
    var modal = getModal();
    if (!modal) return;
    if (typeof modal.showModal === 'function') {
      try { modal.showModal(); } catch (e) { modal.setAttribute('open', ''); }
    } else {
      modal.setAttribute('open', '');
    }
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;
    if (typeof modal.close === 'function') {
      try { modal.close(); } catch (e) { modal.removeAttribute('open'); }
    } else {
      modal.removeAttribute('open');
    }
  }

  function normalize(s) {
    if (!s) return '';
    return s.toLowerCase().trim().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function legendText(legend) {
    if (!legend) return '';
    var clone = legend.cloneNode(true);
    var inners = clone.querySelectorAll('button, .vg-size-trigger, .variant-option__swatch-value');
    for (var i = 0; i < inners.length; i++) inners[i].remove();
    return (clone.textContent || '').trim();
  }

  function injectTrigger(fieldset) {
    if (!fieldset || fieldset.dataset.vgSizeTriggerInjected === '1') return;
    var legend = fieldset.querySelector('legend');
    if (!legend) return;
    var name = normalize(legendText(legend));
    if (name !== 'talla' && name !== 'tallas' && name !== 'size') return;
    if (legend.querySelector('.vg-size-trigger')) {
      fieldset.dataset.vgSizeTriggerInjected = '1';
      return;
    }
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vg-size-trigger';
    btn.setAttribute('data-vg-open-size', '');
    btn.setAttribute('aria-label', 'Abrir guía de tallas');
    btn.innerHTML = '📏 Guía de tallas';
    legend.appendChild(btn);
    fieldset.dataset.vgSizeTriggerInjected = '1';
  }

  function injectAll() {
    var fieldsets = document.querySelectorAll('fieldset.variant-option');
    for (var i = 0; i < fieldsets.length; i++) injectTrigger(fieldsets[i]);
  }

  // Global click handler for any [data-vg-open-size] element — use capture phase
  document.addEventListener('click', function (e) {
    var target = e.target;
    while (target && target !== document.body) {
      if (target.hasAttribute && target.hasAttribute('data-vg-open-size')) {
        e.preventDefault();
        e.stopPropagation();
        openModal();
        return;
      }
      if (target.hasAttribute && target.hasAttribute('data-vg-close-size')) {
        e.preventDefault();
        closeModal();
        return;
      }
      target = target.parentNode;
    }
  }, true);

  // Close on backdrop click
  document.addEventListener('click', function (e) {
    var modal = getModal();
    if (!modal || !modal.hasAttribute('open')) return;
    if (e.target === modal) closeModal();
  });

  // Close on ESC
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var modal = getModal();
      if (modal && modal.hasAttribute('open')) closeModal();
    }
  });

  // Initial inject + observers for AJAX re-renders
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectAll);
  } else {
    injectAll();
  }
  document.addEventListener('shopify:section:load', injectAll);
  document.addEventListener('variant:change', injectAll);

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    var raf = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); };
    raf(function () { injectAll(); pending = false; });
  }
  function startObserver() {
    if (!document.body) return;
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) startObserver();
  else document.addEventListener('DOMContentLoaded', startObserver);
})();
